import { createRouter, createWebHistory } from 'vue-router'
import { useToast } from 'vue-toastification'
import Home from '../views/HomeView.vue'
import NotFounds from '../views/Page/NotFoundsView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/adventure',
    name: 'Adventure',
    component: () => import(/* webpackChunkName: "adventure" */ '../views/Categorys/AdventureView.vue'),
  },
  {
    path: '/arcade',
    name: 'Arcade',
    component: () => import(/* webpackChunkName: "arcade" */ '../views/Categorys/ArcadeView.vue'),
  },
  {
    path: '/puzzles',
    name: 'Puzzles',
    component: () => import(/* webpackChunkName: "puzzles" */ '../views/Categorys/PuzzlesView.vue'),
  },
  {
    path: '/sports',
    name: 'Sports',
    component: () => import(/* webpackChunkName: "sports" */ '../views/Categorys/SportsView.vue'),
  },
  {
    path: '/strategy',
    name: 'Strategy',
    component: () => import(/* webpackChunkName: "strategy" */ '../views/Categorys/StrategyView.vue'),
  },
  {
    path: '/gamesDetails/:gid',
    name: 'GamesDetails',
    component: () => import(/* webpackChunkName: "gamesDetails" */ '../views/Page/GamesDetailsView.vue'),
    props: true,
    meta: {
      IsAuth: true
    }
  },
  {
    path: '/playGames/:gid',
    name: 'PlayGames',
    component: () => import(/* webpackChunkName: "playGames" */ '../views/Page/PlayGamesView.vue'),
    props: true,
    meta: {
      IsAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/User/LoginView.vue'),
  },
  {
    path: '/unsubscribes',
    name: 'Unsubscribes',
    component: () => import(/* webpackChunkName: "unsubscribes" */ '../views/User/UnsubscribesView.vue'),
    meta: {
      IsAuth: true
    }
  },
  { path: '/:pathMatch(.*)*', name: 'NotFounds', component: NotFounds },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})


router.beforeEach((to, from, next) => {
  const { $cookie } = router.app.config.globalProperties;
  const toast = useToast();

  const isAuthenticated = () => {
    const minutes = parseInt($cookie.getCookie('minutes')) || 0;
    const hasMsisdn = $cookie.isCookieAvailable('msisdn');

    return hasMsisdn && minutes > 0;
  };

  if (to.meta.IsAuth) {
    if (isAuthenticated()) {
      next();
    } else {
      // Check if user has msisdn but minutes are 0
      if ($cookie.isCookieAvailable('msisdn') &&
        parseInt($cookie.getCookie('minutes')) <= 0) {
        toast.error('انتهت مدة اشتراكك، يرجى تجديد الاشتراك', { timeout: 2000 });
      }
      window.location.href = 'https://cgmtnsd.digitalsp.net/648/GElM';
    }
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => {
//   const { $cookie } = router.app.config.globalProperties;

//   const isAuthenticated = () => {
//     return (
//       $cookie.isCookieAvailable('msisdn') &&
//       $cookie.isCookieAvailable('minutes') > 0
//     );
//   };

//   if (to.meta.IsAuth) {
//     if (isAuthenticated()) {
//       next();
//     } else {
//       window.location.href = 'https://cgmtnsd.digitalsp.net/648/GElM';
//     }
//   } else {
//     next();
//   }
// });

export default router
